import React from 'react';
import { FormatComponentProps } from './types';

const InlineCode: React.FC<FormatComponentProps> = ({ content, formulaSelected }) => {
  const inlineCode = content.slice(1, -1);
  return (
    <span onClick={() => formulaSelected?.(inlineCode)} style={{ padding: '2px', cursor: 'pointer', backgroundColor: '#f4f4f4', fontFamily: 'monospace' }}>
      {inlineCode}
    </span>
  );
};

export default InlineCode;
